/** Chat Summary Mid — View More / Learn More(PDP) 클릭 SKU 세션 누적. */

// node 단위 테스트에서도 로드되도록 확장자를 쓴다(tsconfig allowImportingTsExtensions).
import { isAdminPreview } from "../lib/adminPreview.ts";

// Vite 밖(node 단위 테스트)에서는 import.meta.env 가 없다.
const API_BASE = import.meta.env?.VITE_API_BASE || "";

/**
 * fire-and-forget — PDP 이동 전에 호출. 실패해도 UX 차단하지 않음.
 */
export function recordSummaryViewMore(sessionToken: string, sku: string): void {
  const sid = String(sessionToken || "").trim();
  const clean = String(sku || "").trim();
  // Admin 미리보기 클릭은 고객 세션 기록이 아니다.
  if (!sid || !clean || isAdminPreview()) return;
  const url = `${API_BASE}/api/commerce/session/${encodeURIComponent(sid)}/summary-view-more`;
  void fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ sku: clean }),
  }).catch(() => {});
}
